import { Link } from 'react-router-dom'

import { cn } from '@/lib/utils'

import type { SidebarItemTypes } from './SidebarItem.types'

export const SidebarItem = ({
  isActive,
  name,
  linkUrl,
  disabled,
  customOnClick,
}: SidebarItemTypes) => {
  const baseClasses =
    'flex h-8 items-center rounded px-3 py-2 text-xs font-medium transition-colors'

  if (disabled) {
    return (
      <div
        className={cn(baseClasses, 'cursor-not-allowed text-neutralColor30')}
      >
        {name}
      </div>
    )
  }

  return (
    <Link
      to={linkUrl}
      role="button"
      onClick={customOnClick}
      className={cn(
        baseClasses,
        isActive
          ? 'bg-baseColorHighlight text-neutralColor'
          : 'text-neutralColor60 hover:bg-baseColorHighlight hover:text-neutralColor',
      )}
    >
      {name}
    </Link>
  )
}
